<div>
  <diy-label class="data-error-label" *ngIf="question" [labels]="errors"></diy-label>
  <diy-label *ngIf="question" [hidden]="!displayLabel" [labels]="banners" [preview]="preview"></diy-label>
  <diy-label *ngIf="question" [hidden]="!displayLabel" [label]="label" [preview]="preview"></diy-label>
  <div #controls [style.background]="color"></div>
</div>
